import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UserParam } from '@features/users/models/user-param.model';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { BaseComponent } from '../base-component/base.component';
import { RolesConstants } from '@shared/constants';
import { UserApi } from '@shared-features/services';
import { ShipmentCreationTemplateTypes } from '@shared-features/enums/shipments.enum';

@Component({
  selector: 'app-user-params',
  templateUrl: './user-params.component.html',
  styleUrls: ['./user-params.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserParamsComponent extends BaseComponent implements OnChanges {
  @Input() userId: number;
  params: UserParam[] = [new UserParam()];
  form: FormArray;
  ShipmentCreationTemplateTypes = ShipmentCreationTemplateTypes;
  RolesConstants = RolesConstants;
  isEditMode = false;
  displayedColumns = ['name', 'creationTemplate', 'key', 'value'];
  dataSource: MatTableDataSource<UserParam>;

  constructor(private usersApiService: UserApi, private changeDetector: ChangeDetectorRef, private formBuilder: FormBuilder) {
    super();
  }

  ngOnChanges({ userId }: SimpleChanges): void {
    if (userId?.currentValue) {
      this.getUserParams();
    }
  }

  getUserParams(): void {
    this.load(this.usersApiService.getUserParams(this.userId)).subscribe(
      (params: UserParam[]) => this.setupNewParams(params),
      (err) => this.initForm()
    );
  }

  setupNewParams(params: UserParam[]): void {
    this.params = params || [];
    this.dataSource = new MatTableDataSource(this.params || []);
    this.initForm();
    this.isEditMode = false;
    this.changeDetector.markForCheck();
  }

  initForm(): void {
    this.form = this.formBuilder.array(
      this.params.map((param) =>
        this.formBuilder.group({
          id: [param.id],
          name: [param.name, [Validators.required]],
          creationTemplate: [param.creationTemplate, [Validators.required]],
          key: [param.key, [Validators.required]],
          value: [param.value, [Validators.required]],
        })
      )
    );
  }

  addMoreUserParam(): void {
    this.form.push(
      this.formBuilder.group({
        creationTemplate: ['', [Validators.required]],
        name: ['', [Validators.required]],
        key: ['', [Validators.required]],
        value: ['', [Validators.required]],
      })
    );
    this.changeDetector.markForCheck();
  }

  save(): void {
    this.load(this.usersApiService.saveUserParams(this.userId, this.form.value)).subscribe((params) => this.setupNewParams(params));
  }
}
